/**
 *
 * Survey
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import SurveyTemplate from "components/SurveyTemplate"
import Loader from "components/Loader"
import reducer from "./reducer"
import saga from "./saga"
import {
  getSurveyWatcher,
  getSurveyEnpsWatcher,
  updateDimensionWatcher,
  updateQuestionWatcher,
  getDimensionsQuestionWatcher,
  createQuestionWatcher,
  getQuestionTypesWatcher,
  getQuestionWatcher,
  getQuestionSuccess,
  getDimensionWatcher,
  getSurveyQualitativeWatcher,
  updateSurveyWatcher,
  deleteSurveyWatcher,
  deleteAllQuestionsWatcher,
  updateQuestionDimensionWatcher,
  deleteQuestionWatcher,
  updateQualitativeWatcher,
  getConfigSurveyWatcher,
  updateConfigSurveyWatcher,
  downloadSurveyWatcher,
  getQuestionsWatcher,
  sendEmailPreviewSurvey,
  uploadBgImageWatcher,
  uploadLogoWatcher,
  getQuestionsMultipleChoiceWatcher,
  getSegmentsWatcher,
  getSurveyTypesWatcher,
  getScopeTypesWatcher,
} from "./actions"
import {
  makeSelectSurveys,
  makeSelectIsLoadingSurvey,
  makeSelectDimensionsQuestion,
  makeSelectIsLoadingDimensionsQuestion,
  makeSelectQuestionTypes,
  makeSelectIsLoadingQuestionTypes,
  makeSelectQuestion,
  makeSelectIsLoadingQuestion,
  makeSelectIsLoadingSurveyEnps,
  makeSelectSurveyEnps,
  makeSelectIsLoadingDimension,
  makeSelectDimension,
  makeSelectSurveyQualitative,
  makeSelectIsLoadingSurveyQualitative,
  makeSelectIsLoadingDeleteAllQuestions,
  makeSelectSurveyName,
  makeSelectIsLoadingConfigSurvey,
  makeSelectConfigSurvey,
  makeSelectQuestions,
  makeSelectUploadBgImage,
  makeSelectIsLoadingUploadBgImage,
  makeSelectUploadLogo,
  makeSelectIsLoadingUploadLogo,
  makeSelectEngagement,
  makeSelectIsLoadingCreateQuestion,
  makeSelectIsErrorCreateQuestion,
  makeSelectListQuestionMultipleChoice,
  makeSelectSegments,
  makeSelectIsLoadingSegments,
  makeSelectSurveyTypes,
  makeSelectIsLoadingSurveyTypes,
  makeSelectScopeTypes,
  makeSelectIsLoadingScopeTypes,
  makeSelectHasLikertQuestions,
} from "./selectors"

import { uploadTemplateFailed } from "../SurveysImport/actions"
import { isModuleBySlug,LOCAL_MODULES } from "../../utils/storage"
import { MULTIPLE_CHOICE, SEGMENTS } from "../../utils/constants"

/* eslint-disable react/prefer-stateless-function */
export class Survey extends React.Component {
  state = { isLoadingSurveyTemplate: true, forceReload: false }

  componentDidMount = () => {
    if (!JSON.parse(LOCAL_MODULES()).some(module => module.slug === 'surveys')) {
      this.props.history.push("/")
    }
    this.loadSurvey()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.forceReload) {
      this.loadSurvey()
      this.setState({
        forceReload: false,
      })
    }
  }

  loadSurvey = () => {
    const { match } = this.props

    const isMultipleChoiceEnable = isModuleBySlug(MULTIPLE_CHOICE)
    const isSegmentsEnabled = isModuleBySlug(SEGMENTS)

    this.props.getSurveyWatcher(match.params.id)
    this.props.getSurveyEnpsWatcher(match.params.id)
    this.props.getSurveyQualitativeWatcher(match.params.id)
    this.props.getDimensionsQuestionWatcher(match.params.id)
    this.props.getConfigSurveyWatcher(match.params.id)
    this.props.getQuestionsWatcher(match.params.id)
    this.props.uploadBgImageWatcher({ idSurvey: match.params.id })
    this.props.uploadLogoWatcher({ idSurvey: match.params.id })
    this.props.getSurveyTypes()
    this.props.getScopeTypes()

    if (isMultipleChoiceEnable) {
      this.props.getQuestionsMultipleChoiceWatcher(match.params.id)
    }

    if (isSegmentsEnabled) {
      this.props.getSegments()
    }

    setTimeout(() => {
      this.setState({ isLoadingSurveyTemplate: false })
    }, 2000)
  }

  urlBack = () => {
    this.props.uploadTemplateFailed(false)
    const url = `/models/surveys/import/${this.props.match.params.id}`
    this.props.history.push(url)
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Encuestas - Cuestionarios</title>
          <meta name="description" content="Description of Survey" />
        </Helmet>
        {this.props.isLoadingConfigSurvey ||
        this.state.isLoadingSurveyTemplate ? (
          <Loader />
        ) : (
          <SurveyTemplate
            {...this.props}
            forceReload={(status) =>
              this.setState({
                forceReload: status,
              })
            }
            url={this.urlBack}
          />
        )}
      </React.Fragment>
    )
  }
}

Survey.propTypes = { getSurveyWatcher: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  survey: makeSelectSurveys(),
  engagement: makeSelectEngagement(),
  isLoadingSurvey: makeSelectIsLoadingSurvey(),
  dimensionsQuestion: makeSelectDimensionsQuestion(),
  isLoadingDimensionsQuestion: makeSelectIsLoadingDimensionsQuestion(),
  questionTypes: makeSelectQuestionTypes(),
  question: makeSelectQuestion(),
  isLoadingQuestion: makeSelectIsLoadingQuestion(),
  isLoadingSurveyEnps: makeSelectIsLoadingSurveyEnps(),
  surveyEnps: makeSelectSurveyEnps(),
  isLoadingQuestionTypes: makeSelectIsLoadingQuestionTypes(),
  isLoadingDimension: makeSelectIsLoadingDimension(),
  dimension: makeSelectDimension(),
  surveyQualitative: makeSelectSurveyQualitative(),
  isLoadingSurveyQualitative: makeSelectIsLoadingSurveyQualitative(),
  isLoadingDeleteAllQuestions: makeSelectIsLoadingDeleteAllQuestions(),
  surveyName: makeSelectSurveyName(),
  isLoadingConfigSurvey: makeSelectIsLoadingConfigSurvey(),
  configSurvey: makeSelectConfigSurvey(),
  questions: makeSelectQuestions(),
  uploadBgImage: makeSelectUploadBgImage(),
  isLoadingUploadBgImage: makeSelectIsLoadingUploadBgImage(),
  uploadLogo: makeSelectUploadLogo(),
  isLoadingUploadLogo: makeSelectIsLoadingUploadLogo(),
  isLoadingCreateQuestion: makeSelectIsLoadingCreateQuestion(),
  isErrorCreateQuestion: makeSelectIsErrorCreateQuestion(),
  listQuestionMultipleChoice: makeSelectListQuestionMultipleChoice(),
  segments: makeSelectSegments(),
  isLoadingSegments: makeSelectIsLoadingSegments(),
  surveyTypes: makeSelectSurveyTypes(),
  isLoadingSurveyTypes: makeSelectIsLoadingSurveyTypes(),
  scopeTypes: makeSelectScopeTypes(),
  isLoadingScopeTypes: makeSelectIsLoadingScopeTypes(),
  hasLikertQuestions: makeSelectHasLikertQuestions()
})

function mapDispatchToProps(dispatch) {
  return {
    deleteQuestionWatcher: (params) => dispatch(deleteQuestionWatcher(params)),
    getSurveyWatcher: (params) => dispatch(getSurveyWatcher(params)),
    updateSurveyWatcher: (params) => dispatch(updateSurveyWatcher(params)),
    getSurveyEnpsWatcher: (params) => dispatch(getSurveyEnpsWatcher(params)),
    updateDimensionWatcher: (params) =>
      dispatch(updateDimensionWatcher(params)),
    updateQuestionWatcher: (params) => dispatch(updateQuestionWatcher(params)),
    getDimensionsQuestionWatcher: (params) =>
      dispatch(getDimensionsQuestionWatcher(params)),
    createQuestionWatcher: (params) => dispatch(createQuestionWatcher(params)),
    getQuestionTypesWatcher: (params) =>
      dispatch(getQuestionTypesWatcher(params)),
    getQuestionWatcher: (params) => dispatch(getQuestionWatcher(params)),
    getQuestionSuccess: (params) => dispatch(getQuestionSuccess(params)),
    getDimensionWatcher: (params) => dispatch(getDimensionWatcher(params)),
    getSurveyQualitativeWatcher: (params) =>
      dispatch(getSurveyQualitativeWatcher(params)),
    deleteSurveyWatcher: (params) => dispatch(deleteSurveyWatcher(params)),
    deleteAllQuestionsWatcher: (params) =>
      dispatch(deleteAllQuestionsWatcher(params)),
    updateQuestionDimensionWatcher: (params) =>
      dispatch(updateQuestionDimensionWatcher(params)),
    updateQualitativeWatcher: (params) =>
      dispatch(updateQualitativeWatcher(params)),
    getConfigSurveyWatcher: (params) =>
      dispatch(getConfigSurveyWatcher(params)),
    updateConfigSurveyWatcher: (params) =>
      dispatch(updateConfigSurveyWatcher(params)),
    uploadTemplateFailed: (params) => dispatch(uploadTemplateFailed(params)),
    downloadSurveyWatcher: (params) => dispatch(downloadSurveyWatcher(params)),
    getQuestionsWatcher: (params) => dispatch(getQuestionsWatcher(params)),
    sendEmailPreviewSurveyGo: (params) =>
      dispatch(sendEmailPreviewSurvey(params)),
    uploadBgImageWatcher: (params) => dispatch(uploadBgImageWatcher(params)),
    uploadLogoWatcher: (params) => dispatch(uploadLogoWatcher(params)),
    getQuestionsMultipleChoiceWatcher: (params) =>
      dispatch(getQuestionsMultipleChoiceWatcher(params)),
    getSegments: (params) => dispatch(getSegmentsWatcher(params)),
    getSurveyTypes: (params) => dispatch(getSurveyTypesWatcher(params)),
    getScopeTypes: (params) => dispatch(getScopeTypesWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "survey", reducer })
const withSaga = injectSaga({ key: "survey", saga })

export default compose(withReducer, withSaga, withConnect)(Survey)
